import { Component } from '@verndale/core';

class AirlineTiers extends Component {
  setupDefaults() {
    this.dom = {
      $document: $(document),
      $tiers: this.$el.find('.airline-tier'),
      $buttons: this.$el.find('.airline-tier__button')
    };
  }

  addListeners() {
    this.dom.$document.on('touchend', ::this.handleClickOutside);
  }

  handleClickOutside(e) {
    const $target = $(e.target);
    if (!$target.closest(this.dom.$tiers).length) {
      this.dom.$buttons.blur();
    }
  }
}

export default AirlineTiers;
